import React from "react";
import styled from "styled-components";
import "./App.css";
import { Header } from "./components/Header";
import { Router } from "./pages/router";
import { Footer } from "./components/Footer";
import { themes } from "./Utils/themes";
import Scroll from "./components/Scroll";

export const AppWrap = styled.div`
  background-color: ${themes.colors.white};
`;

export const Main = styled.div`
  margin: 0 auto;
`;

function App() {
  return (
    <AppWrap>
      <Header />
      <Main>
        <Scroll />
        <Router />
      </Main>
      <Footer />
    </AppWrap>
  );
}

export default App;
